export default "__VITE_ASSET__CZOVf0wh__"